const sanitizeCompanyName = (companyName: string) => {
    return companyName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

export { sanitizeCompanyName };